'use strict';

const DISABLE_SCROLL_CLS = 'is-scrollDisabled';
const bodyScroll = [
  '$window',
  'scrollTop',

  function ($window, scrollTop) {
    var body = $window.document.body;
    var bodyEl = angular.element(body);
    var wrapper = document.querySelector('.Wrapper');
    var wrapperEl = angular.element(wrapper);
    var callCount = 0;
    var offsetY;

    return {

      /**
       * Disables body scroll.
       */
      disable: function () {
        if (!callCount) {
          offsetY = scrollTop();
          bodyEl.addClass(DISABLE_SCROLL_CLS);
          wrapperEl.css('top', -offsetY + 'px');
        }

        callCount++;
      },

      /**
       * Enables body scroll.
       */
      enable: function () {
        if (callCount > 0) {
          callCount--;
        }

        if (!callCount) {
          bodyEl.removeClass(DISABLE_SCROLL_CLS);
          wrapperEl.css('top', 0);
          scrollTop(offsetY);
        }
      }
    };
  }
];

export default bodyScroll;



// WEBPACK FOOTER //
// ./app/src/services/body_scroll.js